import React from 'react';
import {
  TableRow, TableCell,
} from '@mui/material';
import { useTranslation } from './LocalizationProvider';
import { useGlobalStyles } from '../util/classes';
import { getSignal, getOperator } from './CommonValues';
import {
  Operator, Signal, GPS, Power, Battery, Ignition, Motion, Alarm, LotStatus, StaleData, SnoozeStatus,
} from './CommonObjects';
import { getLotStatus, isSnoozed } from '../../main/filterUtil';
import { useStale } from '../util/stale';

const StandardProps = ({ status, position, device }) => {
  const classes = useGlobalStyles();
  const t = useTranslation();

  const lotStatus = getLotStatus(device);
  const snoozed = isSnoozed(device);
  const stale = useStale(device);

  return (
    <TableRow>
      {stale.stale && position && (
        <TableCell colSpan={2} className={classes.cell} style={{ padding: 0 }}>
          <StaleData t={t} {...stale} />
          {lotStatus && (
            <LotStatus t={t} lotStatus={lotStatus} />
          )}
          {snoozed && (
            <SnoozeStatus t={t} snoozeUntil={device.snoozeUntil} />
          )}
        </TableCell>
      )}
      {!stale.stale && status === 'online' && position && (
        <TableCell colSpan={2} className={classes.cell} style={{ padding: 0 }}>
          {position.attributes.hasOwnProperty('io1') && position.attributes.hasOwnProperty('io2') && (
            <Operator t={t} operator={getOperator(position.attributes.io1, position.attributes.io2)} />
          )}
          {position.attributes.hasOwnProperty('rssi') && (
            <Signal t={t} signal={getSignal(position.attributes.rssi)} />
          )}
          {position.attributes.hasOwnProperty('hdop') && (
            <GPS t={t} hdop={position.attributes.hdop} />
          )}
          {position.attributes.hasOwnProperty('power') && (
            <Power t={t} power={position.attributes.power} />
          )}
          {position.attributes.hasOwnProperty('batteryLevel') && (
            <Battery t={t} batteryLevel={position.attributes.batteryLevel} charging={position.attributes.charge} />
          )}
          {position.attributes.hasOwnProperty('ignition') && (
            <Ignition t={t} ignition={position.attributes.ignition} />
          )}
          {position.attributes.hasOwnProperty('motion') && !position.attributes.motion && (
            <Motion t={t} motion={position.attributes.motion} />
          )}
          {position.attributes.hasOwnProperty('alarm') && (
            <Alarm t={t} alarm={position.attributes.alarm} />
          )}
          {lotStatus && (
            <LotStatus t={t} lotStatus={lotStatus} />
          )}
          {snoozed && (
            <SnoozeStatus t={t} snoozeUntil={device.snoozeUntil} />
          )}
        </TableCell>
      )}
      {!stale.stale && status !== 'online' && position && (
        <TableCell colSpan={2} className={classes.cell}>
          <Signal t={t} signal={0} />
          {position.attributes.hasOwnProperty('power') && (
            <Power t={t} power={position.attributes.power} />
          )}
          {position.attributes.hasOwnProperty('batteryLevel') && (
            <Battery t={t} batteryLevel={position.attributes.batteryLevel} charging={position.attributes.charge} />
          )}
          {position.attributes.hasOwnProperty('alarm') && (
            <Alarm t={t} alarm={position.attributes.alarm} />
          )}
          {lotStatus && (
            <LotStatus t={t} lotStatus={lotStatus} />
          )}
          {snoozed && (
            <SnoozeStatus t={t} snoozeUntil={device.snoozeUntil} />
          )}
        </TableCell>
      )}
    </TableRow>
  );
};

export default StandardProps;
